<hmd-list-page class="list-page">
  <template #body>
    <div class="zhezhao" v-if="displayQuanping"></div>
    <div class="ub ub-ac ub-ps ub-ver progress" :class="displayQuanping?'quanping':''">
      <div class="ub ub-ac ub-pc fw title">{{ planData?.projectName }}</div>
      <a-row class="ub ub-ac ub-pc fw">
        <a-col :span="6">
          <div class="ub ub-ac ub-ps sub-title">项目编号：{{planData?.projectBizNo }}</div>
          <div class="ub ub-ac ub-ps sub-title">
            最新进度填报日期：
            <span> {{planData?.lastWriteDate }} </span>
            <!-- <template v-else>-</template> -->
          </div>
        </a-col>
        <a-col :span="5">
          <div class="ub ub-ac ub-ps sub-title">工程合同： {{planData?.contractName }}</div>
          <div class="ub ub-ac ub-ps sub-title">
            最新进度填报：
            <a
            
              class="ml-auto"
              href="javascript:void(0)"
              @click="goto()"
              v-if="planData?.lastWriteBizNo"
            >
              {{ planData?.lastWriteBizNo }}
            </a>
            <template v-else>-</template>
          </div></a-col
        >
        <a-col :span="3">
          <div class="ub ub-ac ub-ps sub-title">
            计划工期：<span class="plan-color-span"></span>
          </div>
        </a-col>
        <a-col :span="4">
          <div class="ub ub-ac ub-ps sub-title">
            正常推进：<span class="advance-color-span"></span>
          </div>
          <div class="ub ub-ac ub-ps sub-title">
            滞后推进/延期中：<span class="advance-color-span bg1"></span>
          </div>
          <div class="ub ub-ac ub-ps sub-title">
            提前启动/超前推进：<span class="advance-color-span bg2"></span>
          </div>
        </a-col>
        <a-col :span="3">
          <div class="ub ub-ac ub-ps sub-title">
            正常完成：<span class="plan-color-span-block"></span>
          </div>
          <div class="ub ub-ac ub-ps sub-title">
            延期完成：<span class="plan-color-span-block bg1"></span>
          </div>
          <div class="ub ub-ac ub-ps sub-title">
            超前完成：<span class="plan-color-span-block bg2"></span>
          </div>
        </a-col>
        <a-col :span="3">
          <a-checkbox
            :checked="planData?.excludeHolidays==1"
            v-if="planData?.excludeHolidays==1"
            :disabled="true"
            class="wauto"
            >去掉法定节假日
            <a-tooltip trigger="hover" placement="top" class="append-to-body" arrow-point-at-center>
              <template #title>
                国务院办公厅尚未发布“{{(new Date()).getFullYear()+1
                }}年度法定节假日安排”通知；跨年施工计划，其“甘特图”、“工期”和“计划进度”统计可能存在差异，请知晓。
              </template>
              <span style="cursor: pointer; color: rgba(0, 0, 0, 0.45)">
                <ant-icon type="QuestionCircleOutlined"></ant-icon>
              </span> </a-tooltip
          ></a-checkbox>
          <a-checkbox
            :checked="planData?.restType==1"
            v-if="planData?.restType==1"
            :disabled="true"
            class="wauto"
            >双休制</a-checkbox
          >
          <a-checkbox
            :checked="planData?.restType==2"
            v-if="planData?.restType==2"
            :disabled="true"
            class="wauto"
            >单休制({{planData?.singleRestDay==6?'周六':'周日'}})</a-checkbox
          >
        </a-col>
      </a-row>

      <!-- <div class="ub ub-pe ub-ac fw" style="margin-bottom: 10px">
        <div class="total-tips">共计{{ tableData.length }}条</div>
        <div class="ub ub-ac ub-pc quanping-btn" v-if="!displayQuanping" @click="openFn">
          <img src="@/assets/images/openquanping.png" class="quanping-icon" />
          <div class="quanping-text">全屏</div>
        </div>
        <div class="ub ub-ac ub-pc quanping-btn" v-else @click="closeFn">
          <img src="@/assets/images/exitquanping.png" class="quanping-icon" />
          <div class="quanping-text">退出全屏</div>
        </div>
      </div> -->

        <div class="ub fw ub-ac zhezhao2" v-if="loading||comLoading">
          <a-spin :spinning="loading||comLoading" class="ub spin-loading"></a-spin>
        </div>

      <vxe-table
        class="fw responsive-table a-table gantt-table"
        border
        ref="tableRef"
        :header-cell-class-name="headerCellClassName"
        :height="tableHeight"
        :data="tableData"
        :row-config="{keyField: 'uuid'}"
        :tree-config="{rowField: 'uuid', parentField: 'parentId',expandAll: true}"
        :scroll-x="{enabled: true}"
        :seq-config="{seqMethod }"
      >
        <vxe-column type="seq" width="60" title="序号" align="center" fixed="left">
        </vxe-column>
        <vxe-column
          show-overflow
          width="200"
          align="left"
          tree-node
          title="分组/任务名称"
          fixed="left"
        >
          <template #default="{row}"> {{row?.groupName?row?.groupName:row?.content}} </template>
        </vxe-column>
        <vxe-column
          field="progressStatusName"
          align="left"
          width="70"
          title="进度状态"
          fixed="left"
        ></vxe-column>
        <vxe-column field="planCount" align="left" width="70" title="工程量">
          <template #default="{row}">
            <span v-if="row.parentId!='0'">{{row?.planCount}}</span>
          </template>
        </vxe-column>
        <vxe-column field="unit" align="left" width="70" title="结算单位">
          <template #default="{row}"
            ><span class="pl5" v-if="row.parentId!='0'">
              {{row?.unit=='task'?'任务':row?.unit}}</span
            >
          </template>
        </vxe-column>
        <vxe-column field="actualCount" align="left" width="70" title="已完成工程量">

          <template #default="{row}"
          ><span class="pl5" v-if="row.parentId!='0'">
            {{row?.actualCount}}</span
          >
        </template>
        </vxe-column>
        <vxe-column field="planProgress" align="left" width="70" title="计划进度（%）">
          <template #default="{row}">
            <span class="pl5">{{row?.planProgress}}% </span></template
          ></vxe-column
        >
        <vxe-column field="actualProgress" align="left" width="70" title="实际进度（%）">
          <template #default="{row}"
            ><span class="pl5"> {{row?.actualProgress}}% </span></template
          ></vxe-column
        >
        <vxe-column
          field="planStartDate"
          align="left"
          width="110"
          title="计划开始日期"
        ></vxe-column>
        <vxe-column field="planEndDate" align="left" width="110" title="计划完成日期"></vxe-column>
        <vxe-column field="planUseDay" align="left" width="80" title="计划工期" />

        <vxe-column
          field="actualStartDate"
          align="left"
          width="110"
          title="实际开始日期"
        ></vxe-column>
        <vxe-column
          field="actualEndDate"
          align="left"
          width="110"
          title="实际完成日期"
        ></vxe-column>
        <vxe-column field="actualUseDays" align="left" width="80" title="实际工期" />
        <vxe-colgroup title="施工时间/天" align="center">
          <template v-for="(item,index) in headerTh">
            <vxe-colgroup :title="item.title" align="center" min-width="28">
              <template v-for="(o,i) in item.children">
                <vxe-column
                  :title="o.day+''"
                  align="center"
                  :min-width="item.children.length<2?64:28"
                >
                  <template #default="{ row }">
                    <template
                      v-if="new Date(item.title+'-'+o.str)>=new Date(row.planStartDate)&&new Date(item.title+'-'+o.str)<=new Date(row.planEndDate)"
                    >
                      <div class="ub fw plan-color-progress"></div>
                    </template>
                    <!-- <template v-if="row.actualWriteDateList.includes(item.title+'-'+o.str)">
                      <div
                        class="ub fw"
                        :class="'actual-color-progress'+(row.progressStatus-1)"
                      ></div>
                    </template> -->
                    <template v-if="new Date(item.title+'-'+o.str)>=new Date(row.actualWriteDateList[0])&&new Date(item.title+'-'+o.str)<=new Date(row.actualWriteDateList[row.actualWriteDateList.length-1])">
                      <div
                        class="ub fw has-arrow"
                        :class="'actual-color-progress'+(row.progressStatus-1)"
                        v-if="(item.title+'-'+o.str)==row.actualWriteDateList[row.actualWriteDateList.length-1]"
                      ></div>
                      <div
                      class="ub fw"
                      :class="'actual-color-progress'+(row.progressStatus-1)"
                      v-if="(item.title+'-'+o.str)!=row.actualWriteDateList[row.actualWriteDateList.length-1]"
                    ></div>
                    </template>
                    <div class="curr-day" v-if="isToday(item.title+'-'+o.str)"></div>
                    <div class="rest-day" v-if="!isRest(item.title+'-'+o.str)"></div>
                  </template>
                </vxe-column>
              </template>
            </vxe-colgroup>
          </template>
        </vxe-colgroup>
      </vxe-table>
    </div>
  </template>
</hmd-list-page>
